// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"DeviationTooltip_tooltip__sk5tr"};